import { createElementBlock as r, openBlock as o, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function t(d, e) {
  return o(), r("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.852 6.069a3.745 3.745 0 1 1 5.296 5.296 3.745 3.745 0 0 1-5.296-5.296m2.648.449a2.2 2.2 0 1 0 0 4.398 2.2 2.2 0 0 0 0-4.398",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 2a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m5.18 13.14a6.954 6.954 0 1 0-10.36 0 6.716 6.716 0 0 1 10.36 0m-9.206 1.03a6.955 6.955 0 0 0 8.052 0 5.17 5.17 0 0 0-8.052 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const u = { render: t };
export {
  u as default,
  t as render
};
